import { Column } from './column';
import { Feature } from './menu-node.model';
import { EntityMeta, MetaOperatorValue } from './power-search.model';

export enum RoleTypes {
  // Platform level roles
  PLATFORM_OWNER = 1,
  PLATFORM_OPERATOR = 2,

  // Organization level roles
  OWNER = 10,
  ADMIN = 15,
  RESTRICTED = 20,
  VIEWER = 30,
  OPERATIONS = 40,
  EXECUTIVE = 80,
}

export enum FeatureIconType {
  workspace = 'SPACE_DASHBOARD',
  process = 'ACCOUNT_TREE',
  'data_processor' = 'DATABASE',
  model = 'DATA_OBJECT',
  notification = 'NOTIFICATIONS',
  action = 'ASSIGNMENT_IND',
  template_type = 'integration_instructions',
}

export interface RoleScope {
  fId: string;
  featureType: string;
  feature?: Feature;
  meta?: EntityMeta;
  qualifiers: string[];
  condition: { exp: RoleCondition[] } | null;
  editable: boolean;
  sts?: string;
}

export type RoleScopes = Record<string, RoleScope>;

export interface Entitlement {
  title: string;
  isTranslate: boolean;
  scopes: RoleScopes;
  translate: boolean;
}

export type Entitlements = Record<RoleTypes, Entitlement>;

export type EntitlementsWithFeatures = {
  roles: Entitlements;
  features?: Record<string, Feature>;
};

export type EntitlementCell = {
  qualifiers: string[];
  meta: null | EntityMeta;
  condition: { exp: RoleCondition[] } | null;
  editable: boolean;
  sts?: string;
  conditionView: ConditionView[];
};

export type RoleCondition = { v: string[]; k: string; op: string };

export type EntitlementColumn = Column & {
  isEditing: boolean;
  isTranslated: boolean;
};

export type EntitlementsRow = Record<
  string,
  EntitlementCell | string | Feature
> & {
  id: string;
  group: string;
  titleCol: string;
  titleIcon: string;
  details?: Feature;
};

export type ConditionView = {
  name: string;
  operator: MetaOperatorValue;
  values: string[];
};
